import React, { useCallback } from "react";
import ShuffleIcon from "../../icons/ShuffleIcon";
import { View } from "react-native";
import Tooltip from "../../sharedComponents/tooltip/Tooltip";
import StandardText from "../../sharedComponents/standardText/StandardText";
import Colors from "../../styles/colors";

export default function GameConfigIcons({ game, style, enableTooltips = false, iconColor = Colors.onBackground }) {
    const wrapInTooltip = useCallback((children, tooltipContent) => {
        if (enableTooltips) {
            return <Tooltip children={children} content={tooltipContent} customWidth={130} />
        } else {
            return children;
        }
    }, [enableTooltips]);

    return (
        <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: "center", ...style }}>
            {wrapInTooltip(
                <StandardText style={{ ...ownStyles.gameCanastas, backgroundColor: '#FF4A6B' }}>{game.gameConfig.naturalCanastasNeeded ?? '?'}</StandardText>,
                `${game.gameConfig.naturalCanastasNeeded} natural canasta${game.gameConfig.naturalCanastasNeeded > 1 ? 's' : ''} needed`,
            )}

            {wrapInTooltip(
                <StandardText style={{ ...ownStyles.gameCanastas, backgroundColor: '#5A6172' }}>{game.gameConfig.unnaturalCanastasNeeded ?? '??'}</StandardText>,
                `${game.gameConfig.unnaturalCanastasNeeded} unnatural canasta${game.gameConfig.unnaturalCanastasNeeded > 1 ? 's' : ''} needed`,
            )}

            {wrapInTooltip(
                <StandardText style={{ ...ownStyles.gameTurnCount }}>{game.gameConfig.cardsToDeal ?? '??'}</StandardText>,
                `Dealing ${game.gameConfig.cardsToDeal} card${game.gameConfig.cardsToDeal > 1 ? 's' : ''}`
            )}

            {game.gameConfig.swipeCards && (wrapInTooltip(
                <View style={{ ...ownStyles.gameSwipeCardIcon }}>
                    <ShuffleIcon size={20} color={iconColor} />
                </View>,
                `Swipe cards enabled`
            ))}
        </View>
    );
}

const ownStyles = {
    gameCanastas: {
        borderRadius: 4,
        paddingVertical: 2,
        paddingHorizontal: 4,
        marginRight: 4,
        color: '#FFFFFF',

        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
        cursor: 'pointer',
        userSelect: "none",
    },

    gameTurnCount: {
        borderRadius: 4,
        padding: 2,
        marginRight: 4,
        color: '#000000',
        backgroundColor: '#FFFFFF',
        marginLeft: 6,
        fontSize: 14,
        borderColor: '#000000',
        borderWidth: 2,
        transform: [
        {
            rotate: '15deg',
        }, {
            scaleX: 0.80,
        }],
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
        cursor: 'pointer',
        userSelect: 'none',
    },

    gameSwipeCardIcon: {
        cursor: 'pointer',
        userSelect: 'none',
    }
}